import styled from "styled-components";

export const SubtitleWrapper = styled.div`
  font-size: 16px;
  font-family: "PoppinsRegular", sans-serif !important;
  line-height: 150%;
`;
